module.exports = __webpack_public_path__ + "img/2025-07-21a_5.16e9fb57.jpg";